import { takeLatest } from 'redux-saga/effects';
import callRequestSaga from '~/sagas/utils/request-saga';
import LegalDocumentsContainerConstants from '~/components/containers/LegalDocumentsContainer/constants';
import LegalDocumentsAPI from '~/api/legal-documents-api';

export function* getLegalDocuments() {
  yield* callRequestSaga(LegalDocumentsAPI.getLegalDocuments, {
    request: LegalDocumentsContainerConstants.GET_LEGAL_DOCUMENTS_REQUEST,
    success:
      LegalDocumentsContainerConstants.GET_LEGAL_DOCUMENTS_REQUEST_SUCCESS,
    failure: LegalDocumentsContainerConstants.GET_LEGAL_DOCUMENTS_REQUEST_ERROR,
  });
}

export function* getLegalDocumentsSaga() {
  yield takeLatest(
    LegalDocumentsContainerConstants.GET_LEGAL_DOCUMENTS,
    getLegalDocuments
  );
}

export default [getLegalDocumentsSaga];
